import { render } from "./ConversationCard.vue?vue&type=template&id=60b9db6f&scoped=true"
import script from "./ConversationCard.vue?vue&type=script&lang=js"
export * from "./ConversationCard.vue?vue&type=script&lang=js"

import "./ConversationCard.vue?vue&type=style&index=0&id=60b9db6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b9db6f"]])

export default __exports__